// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__yHmkr","activeLink":"Navigation_activeLink__7y-jL"};